<div class="bg-black flex justify-start flex-col min-h-screen">
  <app-header></app-header>
  <router-outlet class="mt-20"></router-outlet>
  <app-footer class="mt-10"></app-footer>
</div>
